import React from 'react';

/**
 * The one-line version of an evidence entry. Entries carry long descriptions and
 * up to thirty photos, so a page of them was an enormous scroll — this collapses
 * each to a scannable row that opens on click.
 */
export function EntrySummaryRow({ entry, codes, apprenticeName, photoCount, open, onToggle }) {
  const status = entry.status || 'pending';
  const summary = entry.fault_reason
    || entry.what_doing
    || entry.title
    || 'No description';

  return (
    <div
      onClick={onToggle}
      style={{
        display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px',
        cursor: 'pointer', flexWrap: 'wrap',
      }}
    >
      <span style={{ color: 'var(--muted)', fontSize: 11, width: 10, flexShrink: 0 }}>{open ? '▾' : '▸'}</span>

      <div style={{ minWidth: 150, flex: '1 1 260px' }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap' }}>
          <span style={{ fontFamily: 'var(--font-d)', fontWeight: 700, fontSize: 11.5, letterSpacing: .5, color: 'var(--accent)' }}>
            {codes.join(', ') || entry.unit_code || '—'}
          </span>
          {apprenticeName && (
            <span style={{ fontSize: 11.5, fontWeight: 600, color: 'var(--head)' }}>{apprenticeName}</span>
          )}
        </div>
        <div style={{ fontSize: 11.5, color: 'var(--muted)', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 420 }}>
          {summary}
        </div>
      </div>

      <div style={{ fontSize: 11, color: 'var(--muted)', whiteSpace: 'nowrap' }}>
        Job #{entry.job_number}
        {entry.vehicle_rego ? ` · ${entry.vehicle_rego}` : ''}
        {' · '}{entry.date}
        {photoCount > 0 && <span> · 📎 {photoCount}</span>}
      </div>

      <span className={`badge ${status}`} style={{ marginLeft: 'auto', flexShrink: 0 }}>{status}</span>
    </div>
  );
}
